export default __webpack_public_path__ + "static/media/icon-agenda.39231765.svg";